/**
 * Shared studio style label — same rule as HubStylesPanel.styleLabel.
 * Prefer the stored name; otherwise "Style <n>".
 */
export function styleDisplayLabel(args: {
  name?: string | null;
  style_number?: number | null;
}): string {
  const name = args.name?.trim();
  if (name) return name;
  if (args.style_number != null) return `Style ${args.style_number}`;
  return "Style";
}
